export const AssetInfo = (props: { asset_info: any }) => {
    return (
        <>
            {props.asset_info}
        </>
    );
};
